import { render, staticRenderFns } from "./FieldHeading.vue?vue&type=template&id=6a7ebf68&scoped=true"
import script from "./FieldHeading.vue?vue&type=script&lang=js"
export * from "./FieldHeading.vue?vue&type=script&lang=js"
import style0 from "./FieldHeading.vue?vue&type=style&index=0&id=6a7ebf68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ebf68",
  null
  
)

export default component.exports